import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { OwlDatetimePickerComponent } from './owl-datetime-picker.component';



@NgModule({
  declarations: [OwlDatetimePickerComponent],
  imports: [
    CommonModule,
    SharedModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  exports:[OwlDatetimePickerComponent]
})
export class OwlDatetimePickerModule { }
